module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space-break2"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("The epigraphs are all by Robert Browning, except one, which is a palpable forgery.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "space-break"
  }, [_vm._v("This is not an autobiographical novel: it is about some "), _c('em', [_vm._v("other")]), _vm._v(" portly, dissolute, immoral and middle-aged art dealer. The rest of the characters are quite imaginary too, especially that Mrs. Spon, but most of the places are real.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0d7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 66
// module chunks = 0